import { Trans, useTranslation } from 'react-i18next';
import type { ProcessExecuteIntervalType, ProcessIntervalAnchor } from '@econtractor/types';

interface ProcessIntervalLabelProps {
    interval: ProcessExecuteIntervalType | null;
    anchor?: ProcessIntervalAnchor | null;
}

const ProcessIntervalLabel = ({ interval, anchor }: ProcessIntervalLabelProps) => {
    const { t } = useTranslation(['Tasks']);
    if (interval?.unit === 'byCoreTask') return <>{t('processDiagram.intervalByCore')}</>;

    const fromDeadline = anchor === 'deadline';
    const anchorClass = fromDeadline ? 'fw-bold text-danger' : 'fw-bold text-success';
    if (!interval || interval.value === 0) {
        if (!fromDeadline) return <>{t('processDiagram.intervalInstant')}</>;
        return (
            <Trans
                ns="Tasks"
                i18nKey="processDiagram.intervalInstantFromDeadline"
                components={{ mark: <span className={anchorClass} /> }}
            />
        );
    }

    return (
        <Trans
            ns="Tasks"
            i18nKey={fromDeadline ? 'processDiagram.intervalOnFromDeadline' : 'processDiagram.intervalOnFromAccept'}
            values={{
                value: interval.value,
                unit: t(`processDiagram.unitsOn.${interval.unit}`),
            }}
            components={{
                num: <span className="fw-bold text-body" />,
                mark: <span className={anchorClass} />,
            }}
        />
    );
};

export default ProcessIntervalLabel;
